<template>
  <div>

    <div>
      <div style='display: inline-block'>
        <a href='#' v-show="changePassword != true" class='button button--secondary' @click.prevent="changePassword = true">Change password</a>
      </div>

      <div v-show='changePassword' class='inputer the-password-form'>
        <input autocomplete="new-password" type='password' :id="id" v-model='password' ref='password'>
        <input type='hidden' ref="password_hidden" :name='name' value=''>
        <aside>
          <a href='#' @click.prevent="viewPassword"><i class='fas fa-eye'></i></a>
          <a href='#' @click.prevent="isShown = !isShown"><i class="fas fa-magic"></i>Generate</a>
        </aside>
      </div>
    </div>

    <div v-show="isShown" class='password-editor'>
        <div class='password-editor__content'>
          <div class='form-group'>
            <label>Generated Password:</label>
            <input type='text' class='password-editor__generated' readonly v-model="generatedPassword">
          </div>

          <div class='form-group form-group-radios'>
            <label>
             <input @change="generate" type="radio" value="0123456789![]{}()%&*$#^<>~@|abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ" v-model="possible">All characters
            </label>
            <label>
             <input @change="generate" type="radio" value="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ" v-model="possible">Easier to say (removes special characters and numbers)
            </label>
            <label>
             <input @change="generate" type="radio" value="abcdefghkmnoprstwxzABCDEFGHJKLMNPQRTWXY34689" v-model="possible">Easier to read (removes look-alike characters)
            </label>
          </div>
          <div class='form-group'>
            <label>Length</label>
            <div class='password-length'>
              <input @input="generate" type='number' min="1" max="50" v-model="length" >
              <input @change="generate" type="range" min="1" max="50" v-model="length" class="slider">
            </div>
          </div>
          <div class='button-group'>
            <a href='#' @click.prevent="fill" class='button button--primary'>Fill password</a>
            <a href='#' @click.prevent="generate" class='button button--secondary'>Refresh</a>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "password-editor",
  props: ["show_button", "name", "id", "value"],
  mounted () {
    if (this.value) {
      this.password = this.value;
    }
    var that = this;
    that.generate()
  },
  watch: {
    password: function (newPassword, oldPassword) {
      this.$refs.password_hidden.value = newPassword;
    }
  },
  methods: {
    viewPassword () {
      if ( this.$refs.password.type == "password") {
        this.$refs.password.type = "text"
      } else {
        this.$refs.password.type = "password"
      }
    },
    fill () {
      this.password = this.generatedPassword;
      this.isShown = false;
    },
    generate () {
      var that = this;
      var i, possible, text;
      text = "";
      i = 0;
      while (i < that.length ) {
        text += that.possible.charAt(Math.floor(Math.random() * that.possible.length));
        i++;
      }
      that.generatedPassword = text
    }
  },

  data: function () {
    return {
      password: "",
      length: 32,
      generatedPassword: "",
      changePassword: !this.show_button,
      isShown: false,
      possible: "0123456789![]{}()%&*$#^<>~@|abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
    }
  }
}
</script>

